<template>
  <div>
    <template v-if="detalhes && detalhes.length > 0">
      <div class="table-outer-title font-weight-bold text-uppercase text-center">
        Detalhes — Viagens
      </div>
      <div class="table-container">
        <table>
          <tr>
            <th>Participante</th>
            <th>CPF</th>
            <th>Descrição</th>
            <th>Data Início</th>
            <th>Data Fim</th>
            <th>Valor</th>
          </tr>
          <tr v-for="(d, i) in detalhes" :key="i">
            <td>{{ d.participante_nome }}</td>
            <td>{{ d.participante_cpf }}</td>
            <td>{{ d.descricao }}</td>
            <td>{{ d.data_inicio | toDate }}</td>
            <td>{{ d.data_fim | toDate }}</td>
            <td>{{ d.valor | toCurrency }}</td>
          </tr>
          <tr class="font-weight-bold">
            <td colspan="5">Total</td>
            <td>{{ totalViagens | toCurrency }}</td>
          </tr>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "DetalhesViagens",
  props: {
    detalhes: {
      type: Array,
      default: function () { return []; },
    },
  },
  computed: {
    totalViagens() {
      return this.detalhes.reduce(function (sum, d) { return sum + (d.valor || 0); }, 0);
    },
  },
};
</script>

<style lang="scss" scoped src="../styles/report.scss"></style>
